import React, { useContext, useState } from "react";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { Box, Button, Typography, styled } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import { useRouter } from "../../../utils/hooks/useRouter";
import { RetailSettingContext } from "../../../services/retail/setting/retailSettingContext";
import {
  getIsStocked,
  sendSetting,
} from "../../../services/retail/setting/retailSettingService";
import { toastError, toastSuccess } from "../../../services/toast/toast";
import { firebaseAndKvaLog } from "../../../services/analytics/analytic.service";
import { Redirect } from "../../../utils/Redirect";
import { isMobile } from "../../../utils/helper";

const StyledOrderConfirmAppBar = styled("div")({
  position: "sticky",
  bottom: 0,
  zIndex: 3,
});

const BorderLinearProgress = styled(LinearProgress)(({}) => ({
  height: 6,
  borderRadius: "2px",
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "rgb(162, 198, 255)",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: "2px",
    backgroundColor: "#0B6BFF",
  },
}));

function LinearProgressWithLabel(props: any) {
  return (
    <Box>
      <Typography
        variant="body1"
        sx={{
          textAlign: "center",
          fontSize: 32,
          "@media (max-width: 600px)": {
            fontStyle: "normal",
            fontFamily: "Inter, sans-serif",
            lineHeight: "28px",
            fontSize: "20px",
            marginBottom: "16px",
          },
        }}
        mb={4}
      >{`${Math.round(props.value)}%`}</Typography>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "100%", mr: 1 }}>
          <BorderLinearProgress variant="determinate" {...props} />
        </Box>
      </Box>
    </Box>
  );
}

export default function SaveBranchButton() {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [progress, setProgress] = useState(50);
  const {
    productStore,
    priceSale,
    pricePromotion,
    synced,
    setSynced,
    setInitSetting,
    setRollback,
    updateProductStore,
    typeRemainOrder,
    initSetting,
    productTypeSetting,
  } = useContext(RetailSettingContext);

  const processing = (toast: any, callback: any) => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          toast();
          setOpen(false);
          clearInterval(timer);
          callback && callback();
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 100);
  };

  const handleToggleBackdrop = async () => {
    setOpen(!open);
    const platform = String(router.query.platform);
    trackingEventSave(platform);
    if (!platform || typeof platform !== "string") {
      return () => {
        Redirect({ to: "/session-expired" });
      };
    }
    try {
      const settingPayload = {
        is_stocked: getIsStocked(typeRemainOrder, productStore),
        price_formula_id: priceSale,
        promotion_formula_id: pricePromotion,
        amount_sale: initSetting.amount_sale,
        platform,
        typeRemainOrder,
        product_type_displayed: productTypeSetting,
      };
      const settingRes = await sendSetting(settingPayload);
      if (settingRes.status === 200) {
        const toast = () => toastSuccess("Lưu thay đổi thành công");
        processing(toast, () => {
          setSynced && setSynced(true);
          updateProductStore && updateProductStore(settingPayload.is_stocked);
          setInitSetting &&
            setInitSetting({
              product_store: settingPayload.is_stocked,
              price_sale: priceSale,
              price_promotion: pricePromotion,
              amount_sale: initSetting.amount_sale,
              type_remain_order: typeRemainOrder,
              product_type_displayed: productTypeSetting,
            });
        });
      }
    } catch (err) {
      const toast = () =>
        toastError(
          `Vui lòng kiểm tra kết nội mạng hoặc quay trở lại sau để tiếp tục thay đổi “Đồng bộ hóa”..`,
          "Không thành công"
        );
      processing(toast, () => {
        setSynced && setSynced(false);
        setRollback && setRollback(Date.now());
      });
    }
  };

  const trackingEventSave = (platform: string) => {
    let eventName = "mk_setting_save";
    if (isMobile()) {
      eventName = "kvapp_mk_setting_save";
    }
    firebaseAndKvaLog(platform, eventName);
  };

  const handleCloseBackdrop = () => {
    // setOpen(false);
  };

  return (
    <StyledOrderConfirmAppBar>
      <Button
        variant="contained"
        disabled={synced ? true : false}
        sx={{
          boxShadow: "none",
          padding: "10px 16px",
          borderRadius: "12px",
          background: "#0070F4",
          fontWeight: 600,
          width: "100%",
          fontSize: "14px",
          lineHeight: "20px",
          fontFamily: "Inter,sans-serif",
          "&:hover,&:focus": {
            backgroundColor: "#004881",
            boxShadow: "none",
          },
          "&:disabled": {
            backgroundColor: "#F8F8F8",
            border: "none",
            color: "#919AA4",
          },
        }}
        onClick={handleToggleBackdrop}
      >
        Lưu
      </Button>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleCloseBackdrop}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box mt={4} sx={{ width: 300 }}>
            <Box sx={{ width: "100%" }}>
              <LinearProgressWithLabel variant="determinate" value={progress} />
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: 18,
                  "@media (max-width: 600px)": {
                    fontStyle: "normal",
                    fontFamily: "Inter, sans-serif",
                    lineHeight: "24px",
                    fontSize: "16px",
                  },
                }}
                mt={2}
              >
                Đang lưu thay đổi ...
              </Typography>
            </Box>
          </Box>
        </Box>
      </Backdrop>
    </StyledOrderConfirmAppBar>
  );
}
